export const setMenuTag = (menu = {}) => {
    const { id = '', } = menu;
    let tagName = '';
    switch (id) {
        case '118': // 投保单
            tagName = '原线上订单'
            break;
        default:
            break;
    }
    return tagName;
}